// Wider mobile-optimized path (20:9 aspect ratio, 1600x720)
// Uses full width with a winding route

export const MOBILE_PATH_POINTS: [number, number][] = [
  [-30, 120],     // start off-screen left
  [100, 120],
  [200, 140],
  [300, 200],
  [280, 300],
  [180, 340],
  [120, 280],
  [140, 200],
  [240, 160],
  [360, 180],
  [440, 240],
  [520, 300],
  [600, 280],
  [680, 220],
  [760, 180],
  [840, 200],
  [900, 260],
  [880, 340],
  [800, 380],
  [740, 340],
  [740, 260],
  [820, 220],
  [920, 240],
  [1000, 300],
  [1080, 360],
  [1160, 380],
  [1240, 340],
  [1300, 380],
  [1360, 440],
  [1420, 480],
  [1480, 520],
  [1540, 560],    // arrive at lodge
]

export const MOBILE_PATH_WIDTH = 28
